import type { StartChatTarget } from '@chat-emp/shared';

import { emitToHost } from '../lib/bridge.js';
import { initChatEmitDetail } from '../lib/gamification.js';

/**
 * A send just created this conversation. `conversation-started` is what flips the
 * host's row off "Start chat"; the reward is job-bounded chats only.
 */
export function announceStarted(
  requestId: number | undefined,
  target: StartChatTarget,
  channelId: string,
): void {
  if (requestId !== undefined) {
    emitToHost('conversation-started', {
      requestId,
      channelId,
      applicantId: target.applicant.id,
      ...(target.job ? { jobId: target.job.id } : {}),
    });
  }
  const reward = initChatEmitDetail({
    channelId,
    jobseekerId: target.applicant.id,
    jobId: target.job?.id,
  });
  if (reward) emitToHost('gamification-action', reward);
}
